export default "__VITE_ASSET__1hsRgEsy__"